const organizations = {
    require_membership: 'کاربر باید عضو سازمان باشد تا ادامه دهد.',
    role_names_not_found: 'نام‌های نقش نامعتبر شناسایی شد: {{names,list(type:conjunction)}}. لطفاً ابتدا این نقش‌ها را ایجاد کنید.',
};
export default Object.freeze(organizations);
